import React from 'react';

const SlideComponentSkeleton = () => {
  return (
    <div className="block bg-[#292929] rounded-lg py-[20px] px-[10px] min-h-[250px] mt-[20px] animate-pulse">
      <div className="flex items-start justify-start gap-4">
        {/* Profile Picture Skeleton */}
        <figure className="w-[97px] h-[97px] translate-y-[-40px]">
          <div className="w-full h-full bg-gray-700 rounded-lg" />
        </figure>
        
        {/* Name and Specialization Skeleton */}
        <div className="flex-1">
          <div className="h-6 w-32 bg-gray-700 rounded mb-2" /> {/* Name skeleton */}
          <div className="h-3 w-24 bg-gray-700 rounded" /> {/* Specialization skeleton */}
        </div>
      </div>

      <div>
        {/* Skills Skeleton */}
        <div className="text-center -mt-[20px] px-[4px]">
          <div className="h-4 w-3/4 mx-auto bg-gray-700 rounded" />
        </div>

        {/* Company Logo Section Skeleton */}
        <div className="mt-[16px] mb-[8px]">
          <div className="h-2 w-24 mx-auto bg-gray-700 rounded mb-4" /> {/* "PREVIOUSLY AT" text skeleton */}
          <div className="w-[80%] h-[60px] mx-auto bg-gray-700 rounded" /> {/* Company logo skeleton */}
        </div>
      </div>
    </div>
  );
};

export default SlideComponentSkeleton;